import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../../../services/http.service';
import { AppConstants } from '../../../../app.constants';
import { LocalStorageService } from 'ng2-webstorage';
import { Observable } from 'rxjs/Rx';
@Injectable()
export class ParentChildService {
    private token: string;
    private schoolId: string;
    selectedYear1: any;
    constructor(private httpClient: HttpClient, private appConstants: AppConstants, private localStorage: LocalStorageService) {
        this.token = this.localStorage.retrieve('Token');
        this.schoolId = this.localStorage.retrieve('SchoolId');

    }
    // public GetChildrenListSearch(pagenum,standardID,sectionID, searchString): Observable<Response> {
    //     if (searchString==null) {
    //         var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('authToken') +'&PageSize=' + 10 + '&pageNumber=' + pagenum;
    //     }
    //     else {
    //         var url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers + '?token=' + this.localStorage.retrieve('authToken') + '&pageNumber=' + pagenum+'&standardID='+standardID+'&sectionID='+sectionID +'&searchString='+searchString;
    //     console.log(url);
    //     }

    //     return this.httpClient.Get(url)
    //         .map(this.extractData)
    //         .catch(this.handleError)
    // }

    public getChildInfo(id): Observable<Response> { //Developed by Sashitha
        let url: string = '' + this.appConstants.baseUrl + "GetStudentDetailsByChildId" + '?token=' + this.token + '&childid=' + id;
        //console.log("getChildInfo", url);

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Hi Edu
    //Hiedu GetHiedu child info Dinidu modify
    public getHIeduChildInfo(id): Observable<Response> { //Developed by Sashitha
        let url: string = '' + this.appConstants.baseUrl + "GetHieduStudentDetailsByChildId" + '?token=' + this.token + '&childid=' + id;
        //console.log("getChildInfo", url);

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

//Hiedu Upadate Student Profile
public updateHiChildInfo(eventPayload): Observable<Response> { //Developed by Sashitha
    let url: string = '' + this.appConstants.baseUrl + "/api/UpdateHieduStudentInfo" /* + '?token=' + this.token */;
    return this.httpClient.Post(url, eventPayload)
        .map(this.extractData)
        .catch(this.handleError)
}

    public getSiblingInfo(childid,parentid,schoolid): Observable<Response> { //Developed by Sashitha
        let url: string = '' + this.appConstants.baseUrl + "GetsblingsListSp" + '?token=' + this.token + '&childId=' + childid + '&parentId=' + parentid + '&Schoolid=' + schoolid;
        //console.log("GetsblingsList", url);

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public updateChildInfo(eventPayload): Observable<Response> { //Developed by Sashitha
        let url: string = '' + this.appConstants.baseUrl + "UpdateStudentInfo" /* + '?token=' + this.token */;
        return this.httpClient.Post(url, eventPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public getChildNameList(pagenum,searchString): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&searchString='+searchString+ '&nuofRows=' + 10 + '&pageNumber=' + pagenum;

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
//-------------------------------------------------------------------------------------------------//
    //Get Course
    public getHigherEdChildCourseList(): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetCourseList" +'?Schoolid=' + /*this.schoolId*/1 ;
        console.log("getHigherEdChildCourseList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get Batch
    public getHigherEdChildBatchList(selectedCourse): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduBatchs" +'?courseid=' + selectedCourse ;
        console.log("getHigherEdChildBatchList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

     //Get Student details//
    public getHiEduChildInfo(selectedCourse, selectedbatch): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduChildInfoBySchoolCourseBatch" +'?Schoolid=' + /*this.schoolId*/1 + '&courseId=' + selectedCourse +'&batchId=' + selectedbatch;
        console.log("GetHiEduChildInfoBySchoolCourseBatch", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

     //Post Student details//
     public postHiEduChildInfo(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "PostHiEduStudentDetails";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }


//----------------------------------------------------------------------------------------------------//
    public GetParentsListSearch(pagenum,standardID,sectionID): Observable<Response> {

        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&standard='+standardID+'&section='+sectionID+'&nuofRows=' + 10 + '&pageNumber=' + pagenum;

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    public GetParentsListBySearch(pagenum,standardID,sectionID,searchString): Observable<Response> {

        if(searchString == null && sectionID == null){
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&standard='+standardID+'&nuofRows=' + 10 + '&pageNumber=' + pagenum;
        }
        else if(searchString == null){
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&standard='+standardID+'&section='+sectionID +'&nuofRows='+ 10 + '&pageNumber=' + pagenum;
        }
        else{
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&standard='+standardID+'&section='+sectionID+'&nuofRows=' + 10 + '&pageNumber=' + pagenum +'&searchString='+searchString;
        }

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    /*public GetParentsList(pagenum, rows): Observable<Response> {
        this.token = this.localStorage.retrieve('Token');
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&nuofRows=' + rows + '&pageNumber=' + pagenum ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }*/
    public GetParentsLists(pagenum, rows,sectionID,standardID): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsList + '?token=' + this.token +'&standard='+standardID+'&section='+sectionID+'&nuofRows=' + rows + '&pageNumber=' + pagenum ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    public GetParentsList(pagenum, rows): Observable<Response> {
        this.token = this.localStorage.retrieve("Token");
        let url: string =
          "" +
          this.appConstants.baseUrl +
          this.appConstants.GetParentsList +
          "?token=" +
          this.token +
          "&nuofRows=" +
          rows +
          "&pageNumber=" +
          pagenum;
        return this.httpClient
          .Get(url)
          .map(this.extractData)
          .catch(this.handleError);
      }

    //jaliya
  public GetParentsListStudentView(pagenum, rows, academicYear): Observable<Response> {
    this.token = this.localStorage.retrieve("Token");
    this.selectedYear1 = this.localStorage.retrieve("GetAcadamicYear");
    let url: string =
      "" +
      this.appConstants.baseUrl +
      this.appConstants.GetParentsListStudentView +
      "?token=" +
      this.token +
      "&academicyearid=" +
      academicYear +
      "&nuofRows=" +
      rows +
      "&pageNumber=" +
      pagenum;
    return this.httpClient
      .Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }

    public updateParentChildList(eventPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateParentChild + '?token=' + this.token ;
        return this.httpClient.Post(url, eventPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    public getClassSectionMap(): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetstandardsectionMapping + '?Schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body;
    }
    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }
    ///////////////////////////////////////////////////////////////////////////////////////////////////


//getting sbaccessroles
public getSbaccessRoles(): Observable<Response> {
    var url: string = '' + this.appConstants.baseUrl + this.appConstants.sbaccessroles + '/' + '?schoolId=' + this.localStorage.retrieve('SchoolId');
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}
//posting Department
public postDepartment(deptPayload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory;
    return this.httpClient.Post(url, deptPayload)
        .map(this.extractData)
        .catch(this.handleError)
}
//previous
// public postNewDepartment(deptPayload): Observable<Response> {
//     let url: string = '' + this.appConstants.baseUrl + this.appConstants.postCategory;
//     return this.httpClient.Post(url, deptPayload)
//         .map(this.extractData)
//         .catch(this.handleError)
// }
//get with page
public GetCategory(pagenum, searchString, isList, size?): Observable<Response> {
    var pagesize = size ? size : 10;
    if (!searchString) {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory + '?schoolId=' + this.localStorage.retrieve('SchoolId')+ '&isList=' + isList + '&PageSize=' + pagesize + '&pageNumber=' + pagenum ;
    }
    else {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory + '?schoolId=' + this.localStorage.retrieve('SchoolId') + '&isList=' + isList + '&PageSize=' + pagesize + '&pageNumber=' + pagenum + '&searchString=' + searchString;
    }

    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}
//get without page
// public GetCategorys(toList): Observable<Response> {
//     var url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory+'?toList='+toList+ '?schoolId='+this.localStorage.retrieve('schoolid');;
//     return this.httpClient.Get(url)
//         .map(this.extractData)
//         .catch(this.handleError)
// }
//previous
// public GetCategory(pagenum, searchString): Observable<Response> {
//     if (!searchString) {
//         var url: string = '' + this.appConstants.baseUrl + this.appConstants.getCategory + '?schoolid=' + this.localStorage.retrieve('schoolid') + '&PageSize=' + 10 + '&pageNumber=' + pagenum;
//     }
//     else {
//         var url: string = '' + this.appConstants.baseUrl + this.appConstants.getCategory + '?schoolid=' + this.localStorage.retrieve('schoolid') + '&PageSize=' + 10 + '&pageNumber=' + pagenum + '&searchString=' + searchString;
//     }

//     return this.httpClient.Get(url)
//         .map(this.extractData)
//         .catch(this.handleError)
// }

public DeleteDepartment(sbAccessRoleId): Observable<Response> {
    var url: string = '' + this.appConstants.baseUrl + this.appConstants.sbaccessroles + '?sbAccessRoleId=' + sbAccessRoleId;
    return this.httpClient.Delete(url)
        .map(this.extractData)
        .catch(this.handleError)
}


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/parentchild-advanceQ.service.ts